/// <reference path="../../../../typings/references.d.ts" />
/// <reference path="../dataaccessfactory.ts" />

module PartnershipModule {

    class SemesterFactory extends DataAccessFactory {

        constructor() {
            super()

            this.defaultActions = {
                query: { method: 'GET', params: this.queryParams }
            }

            this.initialize()
        }


        initialize() {
            var resources: Array<PartnershipsModule.DataAccess.Resource> = [
                {
                    name: 'Semesters',
                    url: 'admin/semesters',
                    actions: {
                        list: {
                            method: 'GET',
                            isArray: true
                        }
                    }
                },
                {
                    name: 'SemesterDetails',
                    url: 'admin/semesters/:semesterCode',
                    params: {
                        semesterCode: '@code'
                    },
                    actions: {
                        query: {
                            method: 'GET',
                            transformResponse: (data) => {
                                if (angular.isString(data)) data = JSON.parse(data)
                                data.endDate = new Date(data.endDate)
                                data.startDate = new Date(data.startDate)
                                return data
                            }
                        },
                        codeUnique: {
                            method: 'POST',
                            url: 'admin/semester-code-unique'
                        },
                        nameUnique: {
                            method: 'POST',
                            url: 'admin/semester-name-unique'
                        },
                        update: {
                            method: 'PUT'
                        },
                        create: {
                            method: 'POST'
                        }
                    }
                }
            ]


            this.process(resources)
        }
    }

    new SemesterFactory()
}

